import React from 'react';
import Trash2 from 'feather-icons-react/build/IconComponents/Trash2';
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_ROTATE_45 } from '../utils/const/estilos-const';
import { useTranslation } from 'react-i18next';

const FooterPregunta = ({ indexSeccion, indexPregunta, handleEliminarPregunta }) => {
    const { t } = useTranslation();

    return (
        <div className="flex justify-between mt-2">
            <label>{t('label_pregunta_nro')}:</label>
            <label style={{ fontWeight: "bold" }}>{indexPregunta}</label>
            <button
                type="button"
                className={`${ESTILO_BOTON_GENERAL_ACEPTAR} flex items-center`}
                onClick={() => handleEliminarPregunta(indexSeccion, indexPregunta)}
                title="ELIMINAR PREGUNTA"
            >
                <Trash2 className={`mr-2 ${ESTILO_ROTATE_45}`} />
                {t('btn_eliminar_pregunta')}
            </button>
        </div>
    );
};

export default FooterPregunta;
